"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.TitleEscrowFactoryGetterMock__factory = void 0;
var _ethers = require("ethers");
function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; } /* Autogenerated file. Do not edit manually. */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const _abi = [{
  inputs: [{
    internalType: "address",
    name: "titleEscrowFactory",
    type: "address"
  }, {
    internalType: "uint256",
    name: "tokenId",
    type: "uint256"
  }],
  name: "callCreate",
  outputs: [],
  stateMutability: "nonpayable",
  type: "function"
}, {
  inputs: [{
    internalType: "address",
    name: "tokenRegistry",
    type: "address"
  }, {
    internalType: "uint256",
    name: "tokenId",
    type: "uint256"
  }],
  name: "getEscrowAddress",
  outputs: [{
    internalType: "address",
    name: "",
    type: "address"
  }],
  stateMutability: "view",
  type: "function"
}, {
  inputs: [{
    internalType: "address",
    name: "_titleEscrowAddress",
    type: "address"
  }],
  name: "setAddress",
  outputs: [],
  stateMutability: "nonpayable",
  type: "function"
}];
const _bytecode = "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";
const isSuperArgs = xs => xs.length > 1;
class TitleEscrowFactoryGetterMock__factory extends _ethers.ContractFactory {
  constructor(...args) {
    if (isSuperArgs(args)) {
      super(...args);
    } else {
      super(_abi, _bytecode, args[0]);
    }
  }
  getDeployTransaction(overrides) {
    return super.getDeployTransaction(overrides || {});
  }
  deploy(overrides) {
    return super.deploy(overrides || {});
  }
  connect(runner) {
    return super.connect(runner);
  }
  static createInterface() {
    return new _ethers.Interface(_abi);
  }
  static connect(address, runner) {
    return new _ethers.Contract(address, _abi, runner);
  }
}
exports.TitleEscrowFactoryGetterMock__factory = TitleEscrowFactoryGetterMock__factory;
_defineProperty(TitleEscrowFactoryGetterMock__factory, "bytecode", _bytecode);
_defineProperty(TitleEscrowFactoryGetterMock__factory, "abi", _abi);